import {NgClass, NgFor} from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  inject,
  viewChild,
  Input
} from '@angular/core';
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_TYPE,
  BUTTON_VARIANT,
  FV_MODAL_EXTERNAL_PADDING_SIZE,
  FV_MODAL_FOOTER_POSITION,
  FV_MODAL_POSITION,
  FV_MODAL_SIZE,
  FvButtonComponent,
  FvModalComponent,
} from '@discocil/fv-components';
import {TranslateModule} from '@ngx-translate/core';
import {LayoutService} from 'src/app/shared/services/layout/layout.service';
import {CashKeyboardPresenter} from './cash-keyboard.presenter';
import {IsMobileDirective} from "@shared/services/layout/directives/is-mobile.directive";

export interface CashKeyboardConfig {
  totalAmount: number;
  currencySymbol: string;
}

@Component({
  selector: 'app-cash-keyboard',
  templateUrl: './cash-keyboard.component.html',
  imports: [
    TranslateModule,
    FvButtonComponent,
    NgFor,
    FvModalComponent,
    NgClass,
    IsMobileDirective
  ],
  providers: [CashKeyboardPresenter],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CashKeyboardComponent implements OnInit, AfterViewInit {
  readonly presenter = inject(CashKeyboardPresenter);
  private readonly layoutService = inject(LayoutService);

  @Input() data?: CashKeyboardConfig;
  @Output() confirmedDeliveredAmount = new EventEmitter<number>();
  @Output() openStateChange = new EventEmitter<boolean>();

  isMobile = this.layoutService.isMobile;
  numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  modalRef = viewChild<FvModalComponent>('modal');

  BUTTON_COLOR = BUTTON_COLOR;
  BUTTON_TYPE = BUTTON_TYPE;
  BUTTON_VARIANT = BUTTON_VARIANT;
  BUTTON_SIZE = BUTTON_SIZE;
  FV_MODAL_SIZE = FV_MODAL_SIZE;
  FV_MODAL_POSITION = FV_MODAL_POSITION;
  FV_MODAL_FOOTER_POSITION = FV_MODAL_FOOTER_POSITION;
  FV_MODAL_EXTERNAL_PADDING_SIZE = FV_MODAL_EXTERNAL_PADDING_SIZE;

  ngAfterViewInit(): void {
    setTimeout(() => this.modalRef()?.open(), 200);
  }

  ngOnInit(): void {
    if (this.data) {
      this.presenter.init(this.data.totalAmount);
    }
  }

  onOpenChange(isOpen: boolean): void {
    this.openStateChange.emit(isOpen);
  }

  onClickSubmit(): void {
    if (!this.presenter.viewModel().isValid) {
      return;
    }

    this.confirmedDeliveredAmount.emit(this.presenter.getDeliveredAmount());
    this.close();
  }

  open(): void {
    this.modalRef()?.open();
  }

  close(): void {
    this.modalRef()?.close();
  }

  trackByNumber(_: number, item: number): number {
    return item;
  }
}
